import Component from '@ember/component';
import { action, set } from '@ember/object';

/*
  attrs
  - cancelRoute
    - the route name to go when cancel is clicked
  - deleteTask
    - the task to run when delete is clicked

*/
export default Component.extend({
  deleteTask: null,
  errorDeleting: false,

  delete: action(function () {
    this.deleteTask.perform().catch(() => {
      set(this, 'errorDeleting', true);
    });
  }),
});
